import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useAsyncEffect from 'use-async-effect';
import Stock from '../../model/Stock';
import { IGlobalState } from '../../model/IGlobalState';
import { ShareRegistryProvider } from '../../model/ShareRegistryProvider';
import ShareRegistryConfig from './ShareRegistryConfig';
import AnimatedSaveButton from '../AnimatedSaveButton';
import AlertEx from '../AlertEx';
import api from '../../api/api';
import { startSetStock } from '../../actions/CurrentStock';

interface IProps {
    ticker: string;
    exchange: string;
    combinedTicker: string;
}

const ShareRegistrySettings: React.FC<IProps> = (props: IProps) => {

    const currentStock = useSelector((state: IGlobalState) => state.currentStock);
    const dispatch = useDispatch();
    const [stock, setStock] = useState<Stock>({ ...currentStock });

    useAsyncEffect(async () => {
        setStock({ ...currentStock });
    }, [currentStock]);

    const onConfigDataChange = (name: string, value: string | boolean | number | object) => {
        setStock({ ...stock, [name]: value } as Stock);
    }
    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => onConfigDataChange(e.target.name, e.target.value);

    const save = async (): Promise<boolean> => {
        const result = await api().saveShareRegistrySettings(props.ticker, props.exchange, {
            shareRegistryProvider: stock.shareRegistryProvider ?? ShareRegistryProvider.None,
            automicClientId: stock.automicClientId || '',
            automicApiKey: stock.automicApiKey || '',
            automicClientSecret: stock.automicClientSecret || '',
            xcendIsEnabled: !!stock.xcendIsEnabled,
        });
        if (result.success) {
            dispatch(startSetStock(props.combinedTicker));
            return true;
        }
        await AlertEx(result.errorMessage || 'Failed to save share registry settings');
        return false;
    }

    return <div>
        <ShareRegistryConfig stock={stock} ticker={props.ticker} exchange={props.exchange}
            onChange={onChange} onConfigDataChange={onConfigDataChange} />
        <div style={{ marginTop: '1rem', display: 'flex', justifyContent: 'flex-end' }}>
            <AnimatedSaveButton onClick={save} />
        </div>
    </div>
}

export default ShareRegistrySettings;
